import { defineMessages } from 'react-intl';


export default defineMessages({
  signInError: {
    id: 'app.containers.App.signInError',
    defaultMessage: 'Login failed!',
  },
});
